import { Capacitor, registerPlugin } from '@capacitor/core';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';

const Documents = registerPlugin('DocumentTools');
export async function exportFile(blob, name) {
  if (Capacitor.getPlatform() !== 'android') {
    const url = URL.createObjectURL(blob), link = document.createElement('a');
    link.href = url; link.download = name; document.body.appendChild(link); link.click(); link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000); return;
  }
  if (blob.size > 25 * 1024 * 1024) throw new Error('This export is larger than 25 MB. Use the website for this file.');
  if (!(await Share.canShare()).value) throw new Error('No export destination is available. Install a files app and retry.');
  const data = await new Promise((resolve, reject) => {
    const reader = new FileReader(); reader.onload = () => resolve(String(reader.result).split(',')[1]); reader.onerror = () => reject(new Error('The export file could not be prepared. Retry.')); reader.readAsDataURL(blob);
  });
  const path = `exports/${crypto.randomUUID()}-${name.replace(/[\\/]/g, '_')}`;
  const written = await Filesystem.writeFile({ path, data, directory:Directory.Cache, recursive:true });
  try { await Share.share({ url:written.uri, title:name, dialogTitle:'Save or share your BudgetPulse export' }); }
  finally { await Filesystem.deleteFile({ path, directory:Directory.Cache }).catch(() => {}); }
}
export async function printReport(html) {
  if (Capacitor.getPlatform() === 'android') await Documents.print({ html, name:'BudgetPulse monthly report' });
  else window.print();
}
